import { render } from "./FormFilePhoto.vue?vue&type=template&id=9a0538ac&lang=pug"
import script from "./FormFilePhoto.vue?vue&type=script&lang=js"
export * from "./FormFilePhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__